import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { store, persistor } from './redux';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import SentryInit from './services/Sentry';

import AppLoading from './components/Loader';
import AppBanner from './components/AppBanner/AppBanner';

import './theme/reset.css';
import './theme/tempUtils.css';
import './theme/base.scss';
import './theme/theme.scss';
import Main from './Main';
import DevTools from './internal/DevTools';
import { includeDevTools } from './constants';

const App = () => {
  useEffect(() => {
    SentryInit();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<AppLoading />}>
        <AppBanner />
        {includeDevTools && <DevTools />}
        <Main />
      </PersistGate>
    </Provider>
  );
};

render(<App />, document.getElementById('app'));

if (module.hot) {
  module.hot.accept();
}
